export default class Pass {
    
    constructor(callback){
        this.callback = callback;
        this.password = '39';
        this._init();
    }

    _init() {
        this._setPassword();
    }

    _setPassword() {
        const $pass = document.querySelector("#js-pass");
        const $passInput = $pass.querySelector("input");
        const $passBtn = $pass.querySelector("button");

        const isLogin = window.DATA.getData('newpass');
        // 前回パスワードを入力済みの場合は入力不要
        if(isLogin == 1){
            $pass.classList.remove("-active");
            this.callback();
            return;
        }
        else{
            $pass.classList.add("-active");
        }
        
        // 入力フォームをリセット
        $passInput.value = '';

        // 入力中
        $passInput.addEventListener('input', ()=>{
            let key = $passInput.value;

            // 入力中の切り替え
            if(key){
                $pass.classList.add("-input");
            } else {
                $pass.classList.remove("-input");
            }
        });
        
        $passBtn.addEventListener('click', ()=>{

            // 入力してない場合は不可
            if(!$pass.classList.contains("-input")){
                return false;
            }

            // キーワードの一致・不一致
            if(this.password == this._toHalfWidth($passInput.value).toUpperCase()) {
                this.callback();
                $pass.classList.remove('-active');
                window.DATA.setData('newpass', 1);
            }
            else {
                $pass.classList.add('-error');
            }
        });
    }

    _toHalfWidth(str){
        
        return str.replace(/[Ａ-Ｚａ-ｚ０-９！-～]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
        });
    }
}